import { ExpirationDuration } from '@/types/Daycare'

export const INVALID_DATES_ERROR: string = 'invalid dates'
export const TOO_MUCH_CHILDREN_ERROR: string = 'Too much children'
export const COUNT_TOO_HIGH: string = 'Not enough slots to edit'
export const SELECT_DATE: string = 'select_date'
export const HOUR_MINUTE_FORMAT: string = 'HH:mm'
export const HOUR_MINUTE_SECOND_FORMAT: string = 'HH:mm:ss'
export const DAY_FORMAT: string = 'DD-MM-YYYY'
export const DAYTIME_FORMAT: string = 'DD-MM-YYYY HH:mm'

export type Expiry =
    | { type: 'date'; expiryDate: string | undefined }
    | { type: 'duration'; expiryDuration: ExpirationDuration }
